import axios from "axios";
import { createContext, useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUsers, useAlerts } from "common";
import { isValidUser } from "app/shared/utils";
import { GET_OUTREACH_CONFIGURATION_CONFIGS } from "app/shared/constants";

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const { currentUser } = useUsers();
  const { setAlert } = useAlerts();
  const [permissions, setPermissions] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isValidUser(currentUser)) {
      (async () => {
        try {
          const response = await axios.get(GET_OUTREACH_CONFIGURATION_CONFIGS);
          setPermissions(response.data.configs);
        } catch (err) {
          setAlert("error", err.message);
        }
      })();

      const isRecruitmentTeam = currentUser.roles.find(({ role }) =>
        ["PI", "CRC"].includes(role)
      );
      if (
        location.pathname === "/" &&
        isValidUser(currentUser) &&
        currentUser.roles.length === 1 &&
        isRecruitmentTeam
      ) {
        navigate("/study-recruitment");
      }
    }
  }, [currentUser, setAlert, location.pathname, navigate]);

  return (
    <PermissionsContext.Provider value={{ permissions }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  return useContext(PermissionsContext);
};
